import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


let httpHeaders = new HttpHeaders()
.set( 'Authorization', 'Bearer ' + localStorage.getItem('token'))
.set('Content-Type', 'application/json');
let options = {
headers: httpHeaders
};

const httpOptions = {
  headers: new HttpHeaders({
    'Authorization': 'Bearer ' + localStorage.getItem('token'),
    'Content-Type': 'application/json'

  })
}


@Injectable({
  providedIn: 'root'
})
export class UserTemplatesService {

  private baseUrl = environment.apiUrl + 'UserTemplates/';
  constructor(private http: HttpClient) { }


  GetUserTemplates(DeviceId: any): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + 'UserTemplates?DeviceId=' + DeviceId, {
      headers: httpHeaders,
      observe: 'response'
    });
  }

  DownloadTemplates(DeviceId: any): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.baseUrl + 'DownloadTemplates?DeviceFrom=' + DeviceId, {
      headers: httpHeaders,
      observe: 'response'
    });
  }

  MigrateUsers(model:any): Observable<any> {
    return this.http.post(this.baseUrl + 'SetUserFromTemplate',model, {
      headers: httpHeaders,
      observe: 'response'
    });
  }
  GetDeviceList(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + 'GetDevice',{
      headers: httpHeaders,
      observe: 'response'
    });
  }

  GetMigrationProgress(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.baseUrl + 'GetActiveDevices',{
      headers: httpHeaders,
      observe: 'response'
    });
  }
}
